import { storageGetItem } from "@/utils/utils";

const GROUP_A_NAME = 'OnlineTest10A';
const GROUP_B_NAME = 'OnlineTest10B';

function getGroupId(){
    if(!window.ip) return ''
    if(ipIsOdd(window.ip)){
        return GROUP_A_NAME;
    }

    return GROUP_B_NAME;
}
/* function getGroupIdNumber(groupId){
    if(!groupId)
        return "";
    let arr = groupId.match(/\d+/g);    
    if(arr && arr.length>0)
        return arr[0];
    return "";
} */
function ipIsOdd(ip){
    if(!ip)return false;
    let lastNum = parseInt(ip.split('.').pop());
    if(lastNum%2===0){// 偶数
        return false;
    }
    return true;

}
function getIp (callback) {
    callback && callback();
    return ''
    // return testGroupId in callback
    let groupId;
    if(!window.ip && window.localStorage){
        let deviceIp =  storageGetItem(localStorage, "online.data.ip");
        if(deviceIp)
            window.ip = deviceIp;
    }

    if(window.ip){
        groupId=getGroupId();
        return callback && typeof callback==='function' && callback(groupId)
    }
}


export default class GoogleAnalyticsApis  {
    constructor() {
        this.jRsRgaSend = this.jRsRgaSend.bind(this);
    }
    setUserId(id){
        if (!window.gtag) return

        gtag('set', {
            'user_id': id
        });
    }
    
    /**
     *
     * @param {String} label
     * @param {String} category
     * @param {String} action
     * @param {String} value
     * @returns {Promise}
     */
    jRsRgaSend (label, category, action, value) {
        return new Promise(function(resolve, /* reject */) {
            if (!label) {
                return;
            }
            if (!action) {
                action = label;
            }
            getIp(function(groupId){
                if (typeof window.gtag !== 'function') {
                    return;
                }
                if (!category) {
                    category = 'PhantomPDF Online JR';
                }

                let post = !!groupId? '_' + groupId:'';

                if (!value) {
                    gtag('event', action + post, {
                        'event_category': category,
                        'event_label': label
                    });
                } else {
                    gtag('event', action + post, {
                        'event_category': category,
                        'event_label': label,
                        'value': value
                    });
                }
    
                resolve();
            });
        });
    }
}




